import React from "react";
import styled, { css } from "styled-components";

const BackButtonForSteps = ({ handlePrevStep }) => (
  <BackButton onClick={handlePrevStep}>
    <BackIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-arrow-left"
      >
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
    </BackIcon>
    Back
  </BackButton>
);

const BackIcon = styled.div`
  color: white;
  margin-right: 8px;
  margin-bottom: 16px;
`;

const BackButton = styled.div`
  cursor: pointer;
  display: flex;
  align-content: center;
  font-family: Montserrat;
  font-weight: 700;
  color: white;
  font-size: 15px;
`;

export default BackButtonForSteps;
